import React from 'react';
import { useAuth } from '../auth/AuthProvider';
import Header from './Header'; // Adjust path if needed
import './Profile.css'; // We'll make a simple CSS file too

function Profile() {
  const { user, isAuthenticated, loginWithRedirect } = useAuth();

  return (
    <div className="profile-page">
      <Header />

      <div className="profile-content">
        <h1>Profile</h1>
        {isAuthenticated ? (
          <div className="profile-details">
            <img src={user.picture} alt="Profile" className="profile-avatar" />
            <h2>{user.name}</h2>
            <p>{user.email}</p>
          </div>
        ) : (
          <div className="profile-login-prompt">
            <p>Please log in to view your profile.</p>
            <button onClick={loginWithRedirect} className="profile-login-button">
              Log In
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
